// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3eEI-","rootCenter":"LoadMoreObserver_rootCenter__17c0_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2bH0J"};